import { createFileRoute } from "@tanstack/react-router";

import { LaunchFailures } from "../features/admin/LaunchFailures";
import { useMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/admin/launch-failures")({
  component: TabRoute,
});

function TabRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <LaunchFailures key={me.data.user.id} me={me.data} />;
}
